class ProductBreadcrumbs extends HTMLElement {
    constructor() {
        super();

        this.collectionLink = this.querySelector('collection-link');
    }

    getChild(html, selector) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.querySelector(selector);
      }

    async getSection(url) {
        try {
            const response = await fetch(`${url}?sections=collection-link`);
            const data = await response.json();
            const collectionLink = this.getChild(data['collection-link'], 'collection-link');
            return collectionLink;
        } catch (error) {
            return null;
        }
    }

    async connectedCallback() {
        let url = '';

        if(this.dataset.collectionUrl){
            url = this.dataset.collectionUrl;
        }else if(document.referrer.includes(`${this.dataset.siteUrl}/collections/`)){
            url = document.referrer;
        }

        if (url) {
            const section = await this.getSection(url);
            if (section) {
                this.collectionLink.innerHTML = section.innerHTML;
            }
        }
        this.style.display = 'block';
    }
}
customElements.define('product-breadcrumbs', ProductBreadcrumbs);